<template lang="pug">
section.BookartSubmit.pa2-m.pa4-l
  form.mw7-ns.center(
    ref='form',
    @submit.prevent.stop='submitForm($event)',
    method='POST',
    enctype='multipart/form-data',
    :action='`${$root.BASE}/api/v1/submit`'
  )
    h3 Submit your project
    p( style='line-height: 1.5') This estimator is intended to provide you with a rough cost estimate. Once you submit your estimate, BookArt will contact you to discuss your project in more detail and provide you with a final quote.
    p.small.mb4 * Indicates a required field.

    input(
      type='hidden',
      name='HTMLSummary',
      :value='HTMLSummary',
    )

    .cf.mb3
      .fl.w-50.pr2
        label( for='firstname' ) First name *
        input(
          type='text',
          name='firstname',
          v-model.trim='model.firstname',
          @input='$v.model.firstname.$touch()',
          @focusout='$v.model.firstname.$touch()'
        )

        .red.f6.mt2( v-if='$v.model.firstname.$error && !$v.model.firstname.required') Required

      .fl.w-50.pl2
        label( for='lastname' ) Last name *
        input(
          type='text',
          name='lastname',
          v-model.trim='model.lastname',
          @input='$v.model.lastname.$touch()',
          @focusout='$v.model.lastname.$touch()'
        )

        .red.f6.mt2( v-if='$v.model.lastname.$error && !$v.model.lastname.required') Required

    .mb3
      label( for='email' ) Email *
      input(
        type='email',
        name='email',
        v-model.trim='model.email',
        @input='$v.model.email.$touch()',
        @focusout='$v.model.email.$touch()',
        style='max-width: 376px;'
      )

      .red.f6.mt2( v-if='$v.model.email.$error && !$v.model.email.required') Required
      .red.f6.mt2( v-if='$v.model.email.$error && $v.model.email.required && !$v.model.email.email') Please enter a valid email

    .mb4
      label( for='postal' ) Postal code
      input(
        type='text',
        name='postal',
        v-model.trim='model.postal',
        style='max-width: 127px;'
      )

    .mb4
      h3.mb0 Deadline

      p.f6.lh-copy.measure.gray.mt1 Please select a project deadline—the date by which you wish to receive the books. Once we have received your submission, we will look over the project details and provide you with a timeline for book production.

      datepicker(
        name='deadline'
        v-model='model.deadline',
        :disabled='disabledDates',
        :inline='true'
      )

    .mb4(v-if="settings.showDesignFilesUpload")
      h3.mb0 Design Files

      p.f6.lh-copy.measure.gray.mt1 If you have your book already designed please provide a low-res PDF. This will help us provide the most accurate estimate. (File must be less than 25MB)

      input(
        name='filepicker'
        ref='filePicker'
        type='file'
        @change='filePickerChange($event)'
        multiple=''
        accept='.pdf'
        style='display: none'
      )

      a.dib.f6.no-underline.tc.bg-near-black.white.bg-animate.hover-bg-dark-gray.pv3.ph4.ttu.tracked(
        href='#',
        @click.prevent='openFilePicker',
      ) Upload PDFs

      ul.Filelist( v-if='designFiles.length > 0' )
        li( v-for='designFile in designFiles' ) {{ designFile.filename }} ({{designFile.size}})

    .mb4
      h3.mb0 Copy edit required?

      p.f6.lh-copy.measure.gray.mt1 Most book submissions contain more errors—often many more—than clients imagine. However, a solid copy edit can protect your credibility and enhance your text by ensuring consistency in regard to spelling, grammar, punctuation, style, page numbering, format issues, and more. Our team of professional copy editors can help.
      p.small.mb4 * Billed separately.

      div
        .Radio
          input#copyediting-yes(
            type='radio'
            name='copyediting',
            value='1',
            v-model='model.copyediting'
          )
          label( for='copyediting-yes' ) Yes

        .Radio
          input#copyediting-no(
            type='radio'
            name='copyediting',
            value='0',
            v-model='model.copyediting'
          )
          label( for='copyediting-no' ) No

    .mb4
      h3.mb0 Graphic design assistance required?

      p.f6.lh-copy.measure.gray.mt1 Attractive, consistent graphic design is a key component of a solid publication. We offer a full range of design services, from image editing, to typography and layout, to polishing your final book design. Let us help you enhance your graphics and tighten up your book’s overall look.
      p.small.mb4 * Billed separately.

      div
        .Radio
          input#designassistance-yes(
            type='radio'
            name='designassistance',
            value='1',
            v-model='model.designassistance'
          )
          label( for='designassistance-yes' ) Yes

        .Radio
          input#designassistance-no(
            type='radio'
            name='designassistance',
            value='0',
            v-model='model.designassistance'
          )
          label( for='designassistance-no' ) No

    .mb4
      h3.mb0 Prepress assistance required?

      p.f6.lh-copy.measure.gray.mt1 So, your book design is complete—but have you prepared the files for print? Bad prepress can result in formatting problems, color distortions, and other inconsistencies. Get the drop on these issues—let us set up your files for proper binding type, ensure the best possible color reproduction, and troubleshoot all your problems before the ink hits the paper.

      div
        .Radio
          input#prepressassistance-yes(
            type='radio'
            name='prepressassistance',
            value='1',
            v-model='model.prepressassistance'
          )
          label( for='prepressassistance-yes' ) Yes

        .Radio
          input#prepressassistance-no(
            type='radio'
            name='prepressassistance',
            value='0',
            v-model='model.prepressassistance'
          )
          label( for='prepressassistance-no' ) No

    <!--.mb4
      h3.mb0 Publishing support required?

      p.f6.lh-copy.measure.gray.mt1 Do you need assistance with publishing your book? Help with obtaining an ISBN steps for approaching distribution and self-distribution,  drafting of copyright terms, preparing royalty agreements and more. Our publishing specialists can help.
      p.small.mb4 * Billed separately.

      div
        .Radio
          input#publishingsupport-yes(
            type='radio'
            name='publishingsupport',
            value='1',
            v-model='model.publishingsupport'
          )
          label( for='publishingsupport-yes' ) Yes

        .Radio
          input#publishingsupport-no(
            type='radio'
            name='publishingsupport',
            value='0',
            v-model='model.publishingsupport'
          )
          label( for='publishingsupport-no' ) No-->

    .mb4
      h3.mb0 Comments and requests

      p.f6.lh-copy.measure.gray.mt1 Please tell us about custom requests or any other important information. This may include custom sizing, finishing techniques, specialty paper choices, or anything you think we ought to know about your book.

      textarea(
        name='comments',
        v-model='model.comments',
        rows='5',
        placeholder='Enter your comments and requests here'
      )
</template>

<script>

import { required, email } from 'vuelidate/lib/validators'
import DatePicker from 'vuejs-datepicker'

import { scrollToEl } from '../../scroll-to-el.js'

export default {

  name: 'bookart-submit',

  props: ['value', 'settings'],

  components: {
    'datepicker': DatePicker
  },

  data: () => ({
    designFiles: [],
    disabledDates: { to: new Date(Date.now()) },
    HTMLSummary: '',
  }),

  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {

    filePickerChange (e) {
      const files = Array.from(e.target.files)
      const size = files.reduce((size, file) => size += file.size, 0)

      if (size > 24 * 1024 * 1024) {
        alert('You can only upload a maximum of 24MB of attached files.')
        e.target.value = null
      } else {
        this.designFiles = files.map(f => ({
          filename: f.name,
          size: (size / 1024 / 1024).toFixed(2) + 'MB'
        }))
      }
    },

    openFilePicker () {
      this.$refs.filePicker.click()
    },

    submitForm (e) {

      if (this.$v.$invalid) {
        this.$v.model.firstname.$touch()
        this.$v.model.lastname.$touch()
        this.$v.model.email.$touch()
        scrollToEl(this.$refs.form)
        return false
      }

      const formData = new FormData(this.$refs.form)

      this.$http.post(`${this.$root.BASE}/api/v1/submit`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(response => {
        this.$emit('success')
      }).catch(err => {
        console.error(err)
        alert(`Sorry, there's been an error on our end :(`)
      })

      return false

    },

  },

  validations: {
    model: {
      firstname: { required },
      lastname: { required },
      email: { required, email },
    }
  },

  mounted () {
    const el = document.querySelector('section.SummaryPanel')
    if (el) this.HTMLSummary = JSON.stringify(el.innerHTML)
  },

}
</script>

<style lang="stylus">

@import '../../styles/vars'

.small
  font-size: 0.8em

label
  display: block
  margin-bottom: 1rem

input
  width: 100%
  border: 1px solid $black
  padding: .5rem

textarea
  width: 100%
  resize: none
  border: 1px solid $black
  padding: .5rem

ul.Filelist
  padding-left: 0
  font-size: .85em

  li:not(:last-child)
    margin-bottom: .5rem

.Radio
  display: inline-block
  margin-bottom: .5rem
  cursor: pointer

  & + .Radio
    margin-left: 1rem

  input
    width: auto
    cursor: pointer

  label
    display: inline
    margin-bottom: 0
    padding-left: .5rem
    cursor: pointer

/* Datepicker overrides */

.calendar
  margin-top: -1px
  border-color: $black !important

.calendar .cell:not(.blank):not(.disabled).day:hover, .calendar .cell:not(.blank):not(.disabled).month:hover, .calendar .cell:not(.blank):not(.disabled).year:hover
  border-color: transparent !important
  background-color: $gray-light !important
  color: $black !important

.calendar .cell.selected, .calendar .cell.selected.highlighted, .calendar .cell.selected:hover
  background-color: $black !important
  color: white !important

</style>



// WEBPACK FOOTER //
// BookartSubmit.vue?122d8d65